import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Icon } from '../../../';
import { ContextConsumer } from './Context';

var SearchSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchSelect, _React$Component);

  var _super = _createSuper(SearchSelect);

  function SearchSelect() {
    var _this;

    _classCallCheck(this, SearchSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "selectRef", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "setCategory", function (_ref) {
      var target = _ref.target;
      var category = target.value;
      _this.props.searchResultsRef.current.scrollTop = 0;

      _this.props.setSearchCategory(category);

      if (typeof _this.props.onChangeSearchCategory === 'function') {
        _this.props.onChangeSearchCategory(category);
      }
    });

    return _this;
  }

  _createClass(SearchSelect, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.searchCategory !== prevProps.searchCategory) {
        // update hidden select's value when category is changed by key binding
        this.selectRef.current.value = this.props.searchCategory;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$categorie = _this$props.categories,
          categories = _this$props$categorie === void 0 ? [] : _this$props$categorie,
          searchCategory = _this$props.searchCategory,
          forwardedRef = _this$props.forwardedRef;
      if (categories.length <= 1) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "cloud-ui-search-select-wrapper",
        ref: forwardedRef
      }, /*#__PURE__*/React.createElement("select", {
        className: "cloud-ui-search-select",
        defaultValue: searchCategory.name,
        onBlur: this.setCategory,
        onChange: this.setCategory,
        ref: this.selectRef
      }, categories.map(function (_ref2, i) {
        var name = _ref2.name,
            shortcut = _ref2.shortcut,
            props = _objectWithoutProperties(_ref2, ["name", "shortcut"]);

        return /*#__PURE__*/React.createElement("option", _extends({
          value: name
        }, props, {
          key: i
        }), name, shortcut && shortcut.name && "\xA0(".concat(shortcut.name, ")"));
      })), /*#__PURE__*/React.createElement("span", {
        className: "cloud-ui-search-select-value"
      }, searchCategory), /*#__PURE__*/React.createElement(Icon, {
        name: "caret-down"
      }));
    }
  }]);

  return SearchSelect;
}(React.Component);

export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ContextConsumer, null, function (_ref3) {
    var searchCategory = _ref3.searchCategory,
        setSearchCategory = _ref3.setSearchCategory,
        searchResultsRef = _ref3.searchResultsRef;
    return /*#__PURE__*/React.createElement(SearchSelect, _extends({}, props, {
      searchCategory: searchCategory,
      setSearchCategory: setSearchCategory,
      searchResultsRef: searchResultsRef,
      forwardedRef: ref
    }));
  });
});